/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Footer_AnalysisInputs */

const en_gc_footer_analysis = /** @type {(inputs: Gc_Footer_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charts & PivotTables`)
};

const zh_gc_footer_analysis = /** @type {(inputs: Gc_Footer_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图表与数据透视表`)
};

/**
* | output |
* | --- |
* | "Charts & PivotTables" |
*
* @param {Gc_Footer_AnalysisInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_footer_analysis = /** @type {((inputs?: Gc_Footer_AnalysisInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Footer_AnalysisInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_footer_analysis(inputs)
	return zh_gc_footer_analysis(inputs)
});
export { gc_footer_analysis as "gc.footer.analysis" }